// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__h832J","left":"InfoRow_left__2WD0R"};